/* global axios */
import ApiClient from './ApiClient';

// Agendas por agente (spec 011): catalogo do seletor e escopo de cada Cenario do Capitao / persona do Agente de IA.
class AgendaScopesAPI extends ApiClient {
  constructor() {
    super('kanban', { accountScoped: true });
  }

  // { practitioners, users, google_calendar_enabled }
  catalog() {
    return axios.get(`${this.url}/agendas`);
  }

  // agentType: 'captain_scenario' | 'ai_persona'
  list(agentType) {
    return axios.get(`${this.url}/agenda_scopes`, {
      params: { agent_type: agentType },
    });
  }

  // Tudo vazio apaga o escopo: o agente volta a usar todas as agendas, como antes.
  save({ agentType, agentId, practitionerIds, userIds, conversationAssignee }) {
    return axios.put(`${this.url}/agenda_scopes`, {
      agent_type: agentType,
      agent_id: agentId,
      practitioner_ids: practitionerIds,
      user_ids: userIds,
      conversation_assignee: conversationAssignee,
    });
  }
}

export default new AgendaScopesAPI();
